import React from "react";
import Button from "@amzn/meridian/button";
import Row from "@amzn/meridian/row";
import { scrollToElement } from "../utils/utils";
import { useBundle } from "@amzn/react-arb-tools";
import { HOMEPAGE_MESSAGE_BUNDLE_NAME } from "../../../constants";
import { t } from "../../../helpers";

const GetStartedButton = ({ targetElement }) => {
  const [bundle] = useBundle(HOMEPAGE_MESSAGE_BUNDLE_NAME);

  return (
    <Row>
      <Button id="scrollButton" onClick={() => scrollToElement(targetElement)}>
        {t(bundle, "get_started")}
      </Button>
    </Row>
  );
};

export default GetStartedButton;
